module.exports = __webpack_public_path__ + "static/img/xgbd.018b2fa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xgbd.jpg
// module id = w+ti
// module chunks = 1